import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCryptoCoin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCryptoCoin"><Path d="M12 6.75V8.5M12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5M12 8.5C13.1155 8.5 14.1091 9.02183 14.75 9.8347M12 15.5V17.25M12 15.5C13.1155 15.5 14.1091 14.9782 14.75 14.1653M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCryptoCoin;
